"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { extractLocalDigits, formatPhoneInput } from "@/shared/auth/phone";
import { RequestStep } from "./request-step";
import { ScheduledStep } from "./scheduled-step";
import { VerifyStep } from "./verify-step";
type Step = "request" | "verify" | "scheduled";
const GRACE_PERIOD_DAYS = 3;
function maskPhone(normalized: string): string {
  const local = extractLocalDigits(normalized);
  if (local.length < 9) {
    return formatPhoneInput(normalized);
  }
  return `+998 ${local.slice(0, 2)} *** ** ${local.slice(7, 9)}`;
}
export function AccountDeletionFlow() {
  const $ = _c(11);
  const [step, setStep] = useState("request");
  const [phone, setPhone] = useState("");
  if (step === "verify") {
    let t0;
    if ($[0] !== phone) {
      t0 = maskPhone(phone);
      $[0] = phone;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => setStep("scheduled");
      t2 = () => setStep("request");
      $[2] = t1;
      $[3] = t2;
    } else {
      t1 = $[2];
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t0) {
      t3 = <VerifyStep maskedPhone={t0} onVerified={t1} onChangePhone={t2} />;
      $[4] = t0;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (step === "scheduled") {
    let t0;
    if ($[6] !== phone) {
      t0 = maskPhone(phone);
      $[6] = phone;
      $[7] = t0;
    } else {
      t0 = $[7];
    }
    let t1;
    if ($[8] !== t0) {
      t1 = <ScheduledStep maskedPhone={t0} graceDays={GRACE_PERIOD_DAYS} />;
      $[8] = t0;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  let t0;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RequestStep onSubmitted={submittedPhone => {
      setPhone(submittedPhone);
      setStep("verify");
    }} />;
    $[10] = t0;
  } else {
    t0 = $[10];
  }
  return t0;
}